import PropTypes from 'prop-types'
import React from 'react'
import './AutoCompleteListStyle.scss'

const AutoCompleteList = ({ list, select, isAddressList = false }) => (
  <div className="auto-complete">
    {list.map((item, index) => {
      // Pour les adresses (strings simples)
      if (isAddressList) {
        return (
          <button key={index} type="button" onClick={() => select(item)}>
            <p>{item}</p>
          </button>
        )
      }

      // Pour les clients (objets avec propriétés)
      return (
        <button
          key={item?.id || index}
          type="button"
          onClick={() => {
            if (item?.active) {
              select(item)
            }
          }}
        >
          <p
            className={!item?.active ? 'client--inactive' : ''}
          >{`${item?.internalId} - ${item?.displayName}`}</p>
        </button>
      )
    })}
  </div>
)

AutoCompleteList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])).isRequired,
  select: PropTypes.func.isRequired,
  isAddressList: PropTypes.bool,
}

AutoCompleteList.defaultProps = {
  isAddressList: false,
}

export default AutoCompleteList
